//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../Features/Features.SheetMetal.FeatureBendPropertiesListBuilder.js";
import "../Features/Features.SheetMetal.MultiThicknessBuilder.js";
import "../no/Features.js";
let d=[[[1,"FlangePropertiesList",0,"Features.SheetMetal.FeatureBendPropertiesListBuilder",0],[0,"MatchFace",1,0],[1,"MultiThicknessProperty",0,"Features.SheetMetal.MultiThicknessBuilder",0],[0,"Plane",1,"Plane",0]],[[["edge"],"IsEdgeValid",{R_:{isValidEdge:''}},1,0]],[]];
SPLM.Features.SheetMetal.MultiFlangeBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.MultiFlangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.MultiFlangeBuilder.MatchFaceOptions = Object.freeze({
    "None" : "None", "UntilSelected" : "UntilSelected"});

export default SPLM;